import {
  educareSpokenEnglishPrime,
  ieltsMockTestPrime,
  academicEnglishPrime,
  ieltsPrime,
  phoneticsPrime,
  msOfficePrime,
  englishWritingPrime,
  careerDevelopmentPrime,
  nayeem,
  riad,
  sakib,
  tipu,
  sohag,
} from "../assets/index";

// ================= Header info start here =====================
export const headerInfo = [
  {
    id: 101,
    title: "home",
    link: "/",
  },
  {
    id: 102,
    title: "courses",
    link: "/courses",
  },
  {
    id: 103,
    title: "about us",
    link: "/aboutus",
  },
  {
    id: 104,
    title: "contact us",
    link: "/contactus",
  },
  {
    id: 105,
    title: "careers",
    link: "/careers",
  },
];
// ================= Header info end here =======================
// ================= courseDetails info start here =====================
export const courseDetails = [
  {
    id: 10001,
    Image: educareSpokenEnglishPrime,
    shadowColor: "168C61",
    link: "/spokenenglish",
    title: "Spoken English",
    des: "Speak English with Confidence",
  },
  {
    id: 10002,
    Image: academicEnglishPrime,
    shadowColor: "4b00e1",
    link: "/academicenglish",
    title: "Academic English",
    des: "Essential English for Academic Achievement",
  },
  {
    id: 10003,
    Image: englishWritingPrime,
    shadowColor: "7d930c",
    link: "/englishwriting",
    title: "English Writing",
    des: "Transforming Thoughts to Text",
  },
  {
    id: 10004,
    Image: ieltsPrime,
    shadowColor: "ac1770",
    link: "/ielts",
    title: "IELTS",
    des: "Unlock Your IELTS Potential: Proven Exam Techniques",
  },
  {
    id: 10005,
    Image: ieltsMockTestPrime,
    shadowColor: "168d6b",
    link: "/ieltsmocktest",
    title: "IELTS Mock Test",
    des: "Mock IELTS Exam Simulation",
  },
  {
    id: 10006,
    Image: phoneticsPrime,
    shadowColor: "5d0559",
    link: "/phonetics",
    title: "Phonetics",
    des: "Foreign Accent: Accent Neutralization and Clarity",
  },
  {
    id: 10007,
    Image: msOfficePrime,
    shadowColor: "b400fe",
    link: "/msoffice",
    title: "Microsoft Office",
    des: "Office Productivity Power-Up",
  },
  {
    id: 10008,
    Image: careerDevelopmentPrime,
    shadowColor: "1fa1ff",
    link: "/careerdevelopment",
    title: "Career Development",
    des: "Pathways to Professional Success",
  },
];
// ================= courseDetails info end here =====================
// ================= CourseTitle info start here =====================

export const courseTitle = [
  {
    id: 2001,
    title: "Spoken English",
  },
  {
    id: 2002,
    title: "Academic English",
  },
  {
    id: 2003,
    title: "English Writing",
  },
  {
    id: 2004,
    title: "IELTS",
  },
  {
    id: 2005,
    title: "IELTS Mock Test",
  },
  {
    id: 2006,
    title: "Phonetics",
  },
  {
    id: 2007,
    title: "Microsoft Office",
  },
  {
    id: 2008,
    title: "Career Development",
  },
];
// ================= CourseTitle info end here =====================
// ================= Instructors Start here ========================
export const instructors = [
  {
    id: 3005,
    Image: sohag,
    hoverDes:
      "Sohag Khan is a Chief Advisor, Corporate Trainer, Business Advisor, Growth Analyst and Motivational Speaker.",
    hoverReadMore: "Chief Advisor,Corporate Training, Motivational Speaking",
    title: "Shohag Khan",
    subject: "Chief Advisor",
  },
  {
    id: 3001,
    Image: tipu,
    hoverDes:
      "Masud Parvej Tipu is a passionate English Academic instructor with 8+ experience as a language trainer, and IELTS expert.",
    hoverReadMore:
      "Spoken English (Basic/Advanced/Professional), Writing English (Basic/Advanced/Professional), ELTS/TOEFL/DuoLingo/PTE, SAT/ACT/GRE/GMAT Specialty.",
    title: "Masud Parvej Tipu",
    subject: "Head Of Faculty, English",
  },
  {
    id: 3002,
    Image: nayeem,
    hoverDes:
      "MD Nayeem Hossain A Phonetic instructor with 5+ years experience as a language trainer.",
    hoverReadMore: "Phonetics, Spoken English.",
    title: "MD Nayeem Hossain",
    subject: "Sr. Instructor, English",
  },
  {
    id: 3003,
    Image: sakib,
    hoverDes:
      "MD Sakib Rahman is a passionate English Academic instructor with 5+ years experience as a language trainer.",
    hoverReadMore: "Academic English, English Grammar, Language Club.",
    title: "MD Sakib Rahman",
    subject: "Sr. Instructor, English",
  },
  {
    id: 3004,
    Image: riad,
    hoverDes:
      "Riad Ahamed is a passionate English Academic instructor with 5+ years experience as a language trainer.",
    hoverReadMore: "Spoken English, Language Club .",
    title: "Riad Ahamed",
    subject: "Sr. Instructor, English",
  },
];
// ================= Instructors end here ==========================

// ====================================================================
//                       About Page Start here
// ====================================================================
// ================= Featuring Modules start here ==========================
export const featuringModules = [
  {
    id: 227,
    title: "Spoken English",
    link: "/spokenenglish",
    des: "Enhance your communication skills and fluency in spoken English",
  },
  {
    id: 228,
    title: "English Writing",
    link: "/englishwriting",
    des: "Improve your writing skills with our creative writing course and English writing tips",
  },
  {
    id: 229,
    title: "IELTS",
    link: "/ielts",
    des: "Prepare for the IELTS exam and achieve your desired band score with our IELTS online course, offline course, and mock tests",
  },
  {
    id: 230,
    title: "Academic English",
    link: "/academicenglish",
    des: "Develop your academic writing and research skills for success in higher education",
  },
  {
    id: 231,
    title: "Microsoft Office",
    link: "/msoffice",
    des: "Learn essential Microsoft Office skills for career growth and job opportunities for freshers",
  },
  {
    id: 232,
    title: "Career Development",
    link: "/careerdevelopment",
    des: "Get ready for interviews with our interview preparation, viva preparation, and career tips",
  },
];
// ================= Featuring Modules end here ============================
// ====================================================================
//                       About Page end here
// ====================================================================
